import { emptySchedule, QuickReply } from "./types";

// No backend for quick replies yet — localStorage is the stand-in so replies
// created in Settings > Conversation Settings show up in the conversation's
// "Send a Quick Reply" picker, and vice versa.
const STORAGE_KEY = "quick_replies";

const SEED_QUICK_REPLIES: QuickReply[] = [
  { id: "1", categoryValue: "greetings", message: "Hello!", addedBy: "John Doe", createdOn: "2025-03-22", status: "Active", schedule: emptySchedule() },
  { id: "2", categoryValue: "greetings", message: "Hi there!", addedBy: "John Doe", createdOn: "2025-03-22", status: "Active", schedule: emptySchedule() },
  { id: "3", categoryValue: "greetings", message: "Good morning!", addedBy: "John Doe", createdOn: "2025-03-22", status: "Active", schedule: emptySchedule() },
  { id: "4", categoryValue: "hold_waiting", message: "Thank you for reaching out.", addedBy: "John Doe", createdOn: "2025-03-22", status: "Disabled", schedule: emptySchedule() },
  { id: "5", categoryValue: "greetings", message: "Welcome! How can I help you today?", addedBy: "John Doe", createdOn: "2025-03-22", status: "Active", schedule: emptySchedule() },
];

export function loadQuickReplies(): QuickReply[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) return JSON.parse(raw);
  } catch {
    // fall through to seed data
  }
  return SEED_QUICK_REPLIES;
}

export function saveQuickReplies(replies: QuickReply[]): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(replies));
  } catch {
    // localStorage unavailable (e.g. private mode) — edits just won't persist.
  }
}
